"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBusinessMembersResponseToJSON = exports.GetBusinessMembersResponseFromJSONTyped = exports.GetBusinessMembersResponseFromJSON = exports.instanceOfGetBusinessMembersResponse = void 0;
var runtime_1 = require("../runtime");
var BusinessMemberResponse_1 = require("./BusinessMemberResponse");
var Paging_1 = require("./Paging");
/**
 * Check if a given object implements the GetBusinessMembersResponse interface.
 */
function instanceOfGetBusinessMembersResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGetBusinessMembersResponse = instanceOfGetBusinessMembersResponse;
function GetBusinessMembersResponseFromJSON(json) {
    return GetBusinessMembersResponseFromJSONTyped(json, false);
}
exports.GetBusinessMembersResponseFromJSON = GetBusinessMembersResponseFromJSON;
function GetBusinessMembersResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paging': !(0, runtime_1.exists)(json, 'paging') ? undefined : (0, Paging_1.PagingFromJSON)(json['paging']),
        'members': !(0, runtime_1.exists)(json, 'members') ? undefined : (json['members'].map(BusinessMemberResponse_1.BusinessMemberResponseFromJSON)),
    };
}
exports.GetBusinessMembersResponseFromJSONTyped = GetBusinessMembersResponseFromJSONTyped;
function GetBusinessMembersResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'paging': (0, Paging_1.PagingToJSON)(value.paging),
        'members': value.members === undefined ? undefined : (value.members.map(BusinessMemberResponse_1.BusinessMemberResponseToJSON)),
    };
}
exports.GetBusinessMembersResponseToJSON = GetBusinessMembersResponseToJSON;
